"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRepeatString = exports.setWeeklyRepeat = exports.setMonthlyRepeat = exports.setDailyRepeat = exports.generateRepeatString = exports.LIST_DELIM = exports.FRAGMENT_DELIM = exports.REPEAT_DELIM = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var constants_1 = require("../constants");
var datetime_1 = require("./datetime");
// Delimits the frequency part from the rest.
exports.REPEAT_DELIM = "*";
// Delimits the fragments of repeatData string.
exports.FRAGMENT_DELIM = ":";
// Delimits parts in one fragment.
exports.LIST_DELIM = ",";
// Position of the REPEAT_DELIM determines the type of the repeat
var REPEAT_TYPE_BY_REPEAT_INDEX = ["none", "yearly", "monthly", "weekly", "daily"];
// Name of the each frangment by position.
var FRAGMENT_BY_INDEX = ["year", "month", "week", "day", "hour", "minute", "second"];
// Fills fragments to respective places.
function fillFragments(fragments, fragObj) {
    for (var name_1 in fragObj) {
        // eslint-disable-next-line no-prototype-builtins
        if (!fragObj.hasOwnProperty(name_1)) {
            continue;
        }
        var index = FRAGMENT_BY_INDEX.indexOf(name_1);
        fragments[index] = fragObj[name_1];
    }
}
function getRepeatBase(repeatType, repeatFrequency) {
    if (repeatType !== constants_1.REPEAT_TYPES.CUSTOM) {
        return repeatType;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (repeatFrequency.hasOwnProperty("day")) {
        return constants_1.REPEAT_TYPES.DAILY;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (repeatFrequency.hasOwnProperty("week")) {
        return constants_1.REPEAT_TYPES.WEEKLY;
    }
    return constants_1.REPEAT_TYPES.MONTHLY;
}
// Generates repeatData string
function generateRepeatString(repeat) {
    var _a, _b;
    var repeatType = repeat.repeatType, repeatFrequency = repeat.repeatFrequency, repeatPeriod = repeat.repeatPeriod, time = repeat.time;
    var fragments = [0, 0, 0, 0, 0, 0, 0];
    var repeatBase = getRepeatBase(repeatType, repeatFrequency);
    var repeatDelimiterIndex = REPEAT_TYPE_BY_REPEAT_INDEX.indexOf(repeatBase);
    // Repeats monthly
    if (repeatBase === constants_1.REPEAT_TYPES.MONTHLY) {
        var str = repeatFrequency.month;
        // Repeats on a day of week in n-th week of month (e.g. 3rd Monday)
        if (((_a = repeatFrequency.month) === null || _a === void 0 ? void 0 : _a.type) === constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK) {
            var day = str.dayOfWeek.day;
            var week = str.dayOfWeek.week;
            fillFragments(fragments, { day: day, week: week });
        }
        // Repeats on a day of month 1-31
        else if (((_b = repeatFrequency.month) === null || _b === void 0 ? void 0 : _b.type) === constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH) {
            var day = str.dayOfMonth;
            fillFragments(fragments, { day: day });
        }
    }
    // Repeats weekly
    else if (repeatBase === constants_1.REPEAT_TYPES.WEEKLY) {
        var days = repeatFrequency.week.days;
        fillFragments(fragments, { day: days.join(exports.LIST_DELIM) });
    }
    // Repeats daily
    else if (repeatBase === constants_1.REPEAT_TYPES.DAILY) {
        // do nothing
    }
    // Fill the repeat period
    fragments[repeatDelimiterIndex - 1] = repeatPeriod;
    // Fill the time
    fillFragments(fragments, time);
    // Split array of fragments into frequency part and when part (so I can join them with '*' afterwards)
    var reptParts = [
        fragments.slice(0, repeatDelimiterIndex),
        fragments.slice(repeatDelimiterIndex, fragments.length),
    ];
    // Join into one repeatData string
    return reptParts.map(function (p) { return p.join(exports.FRAGMENT_DELIM); }).join(exports.REPEAT_DELIM);
}
exports.generateRepeatString = generateRepeatString;
function setDailyRepeat(repeatData) {
    repeatData.repeatFrequency = {
        day: true,
    };
}
exports.setDailyRepeat = setDailyRepeat;
function setMonthlyRepeat(repeatData, repeatExecuteOn, startDate) {
    var _a;
    var repeatExecuteOnData;
    if (repeatExecuteOn === constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH) {
        repeatExecuteOnData = datetime_1.getDate(startDate);
    }
    else if (repeatExecuteOn === constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK) {
        repeatExecuteOnData = {
            day: datetime_1.getDay(startDate),
            week: datetime_1.getWeek(startDate),
        };
    }
    repeatData.repeatFrequency = {
        month: (_a = {
                type: repeatExecuteOn
            },
            _a[repeatExecuteOn] = repeatExecuteOnData,
            _a),
    };
}
exports.setMonthlyRepeat = setMonthlyRepeat;
function setWeeklyRepeat(repeatData, startDate) {
    repeatData.repeatFrequency = {
        week: {
            days: [datetime_1.getDay(startDate)],
        },
    };
}
exports.setWeeklyRepeat = setWeeklyRepeat;
var MONTH_INDEX = 1;
var WEEK_INDEX = 2;
var DAY_INDEX = 3;
var HOUR_INDEX = 4;
var MINUTE_INDEX = 5;
var SECOND_INDEX = 6;
function getFirstUsedFragmentIndex(fragments) {
    var firstFragmentIndex = fragments.findIndex(identity_1.default);
    if (firstFragmentIndex === -1) {
        throw new Error("Invalid recurrence string");
    }
    return firstFragmentIndex;
}
function parseRepeatString(repeat) {
    var fragmentsStrings = repeat.replace(exports.REPEAT_DELIM, exports.FRAGMENT_DELIM).split(exports.FRAGMENT_DELIM);
    var fragments = fragmentsStrings.map(function (s) {
        if (s.indexOf(exports.LIST_DELIM) !== -1) {
            throw new Error("List items are not supported in recurrence string parsing");
        }
        return parseInt(s);
    });
    var firstFragmentIndex = getFirstUsedFragmentIndex(fragments);
    var firstFragmentValue = fragments[firstFragmentIndex];
    var repeatType = constants_1.REPEAT_TYPES.CUSTOM;
    var repeatFrequency = {};
    var customRepeatNumber = firstFragmentValue !== 1;
    if (firstFragmentIndex === MONTH_INDEX) {
        if (fragments[WEEK_INDEX] === 0) {
            repeatType = constants_1.REPEAT_TYPES.CUSTOM;
            repeatFrequency = {
                month: {
                    type: constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH,
                    dayOfMonth: fragments[DAY_INDEX],
                },
            };
        }
        else {
            repeatType = customRepeatNumber ? constants_1.REPEAT_TYPES.CUSTOM : constants_1.REPEAT_TYPES.MONTHLY;
            repeatFrequency = {
                month: {
                    type: constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK,
                    dayOfWeek: {
                        day: fragments[DAY_INDEX],
                        week: fragments[WEEK_INDEX],
                    },
                },
            };
        }
    }
    if (firstFragmentIndex === WEEK_INDEX) {
        repeatType = customRepeatNumber ? constants_1.REPEAT_TYPES.CUSTOM : constants_1.REPEAT_TYPES.WEEKLY;
        repeatFrequency = {
            week: {
                days: [fragments[3]],
            },
        };
    }
    if (firstFragmentIndex === DAY_INDEX) {
        repeatType = customRepeatNumber ? constants_1.REPEAT_TYPES.CUSTOM : constants_1.REPEAT_TYPES.DAILY;
        repeatFrequency = { day: true };
    }
    return {
        repeatType: repeatType,
        repeatFrequency: repeatFrequency,
        repeatPeriod: firstFragmentValue,
        time: {
            hour: fragments[HOUR_INDEX],
            minute: fragments[MINUTE_INDEX],
            second: fragments[SECOND_INDEX],
        },
    };
}
exports.parseRepeatString = parseRepeatString;
//# sourceMappingURL=repeat.js.map